import axios from "axios";
import config from "./config";

const getSubdomain = () => {
  if (process.env.NEXT_PUBLIC_SUBDOMAIN) {
    return process.env.NEXT_PUBLIC_SUBDOMAIN;
  }
  if (typeof window === "undefined") {
    return "proguard";
  }
  return window.location.host.split(".")[1]
    ? window.location.host.split(".")[0]
    : "proguard";
};

const getDomain = () => {
  if (typeof window === "undefined") {
    return "";
  }
  return window.location.hostname;
};

const setAuthToken = (token) => {
  if (typeof window === "undefined") {
    return;
  }
  localStorage.setItem("token", token);
};

const clearAuthToken = () => {
  if (typeof window === "undefined") {
    return;
  }
  localStorage.removeItem("token");
};

const axiosInstance = axios.create({
  baseURL: config.base_url,
  responseType: "json",
});

if (typeof window !== "undefined") {
}

axiosInstance.interceptors.request.use((req) => {
  if (typeof window !== "undefined") {
    req.headers.Authorization = localStorage.getItem("token");
    req.headers.Subdomain = getSubdomain();
    req.headers.Domain = getDomain();
  }
  return req;
});

// for multiple requests
let failedRequests = [];
let isRefreshing = false;
let firebase = null;

const processQueue = (error, token = null) => {
  failedRequests.forEach((prom, i) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedRequests = [];
};

const setFirebase = (fb) => {
  firebase = fb;
};

const waitForAuthenticatedUser = () => {
  return new Promise((resolve, reject) => {
    if (!firebase?.auth) {
      reject(new Error("Authentication is not configured."));
      return;
    }
    if (firebase.auth.currentUser) {
      resolve(firebase.auth.currentUser);
      return;
    }

    let unsubscribe = () => {};
    unsubscribe = firebase.onAuthStateChanged((user) => {
      unsubscribe();
      if (user) {
        resolve(user);
      } else {
        reject(new Error("User is not signed in."));
      }
    });
  });
};

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (!firebase) {
      return Promise.reject(error);
    }

    if (
      error &&
      error.response.status === 401 &&
      error.config &&
      !error.config.__isRetryRequest
    ) {
      const originalRequest = error.config;
      originalRequest.__isRetryRequest = true;

      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedRequests.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = token;
            return axiosInstance(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      isRefreshing = true;

      return new Promise(async (resolve, reject) => {
        try {
          const authUser = await waitForAuthenticatedUser();
          const token = await authUser.getIdToken(true);
          setAuthToken(token);
          processQueue(null, token);
          originalRequest.headers["Authorization"] = token;
          resolve(axiosInstance(originalRequest));
        } catch (err) {
          processQueue(err, null);
          reject(err);
        } finally {
          isRefreshing = false;
        }
      });
    } else {
    }

    return Promise.reject(error);
  }
);

export { setAuthToken, clearAuthToken, setFirebase, getSubdomain };
export default axiosInstance;
